import api, { getAuthParams } from './client';

export const getObjections = (paramsOrId) => {
  const params = typeof paramsOrId === 'object' && paramsOrId !== null
    ? paramsOrId
    : { id: paramsOrId };
  return api.get('/objections', { params: { ...getAuthParams(), ...params } });
};

export const getObjectionDashboard = (payload = {}) =>
  api.post('/objections/dashboard', { ...payload, ...getAuthParams() });
